module.exports = __webpack_public_path__ + "img/customer5.2405fe8d.png";